export const PANEL_RESIZING_CLASS = "panel-resizing";

/** Minimum flex-grow value allowed during drag to prevent panel collapse */
export const MIN_FLEX = 0.1;

/** Flex-grow difference threshold below which two values are treated as equal */
export const FLEX_EPSILON = 0.001;

/**
 * Size difference (px) threshold below which a panel is considered unmoved.
 * Paired with FLEX_EPSILON: a panel is "CSS-capped" when its flex changes by
 * more than FLEX_EPSILON but its rendered size moves by less than this value.
 * In very small containers a tiny flex delta can map to < 0.5 px, causing a
 * benign false-positive (revert); this is self-correcting on the next frame
 * as a larger delta accumulates.
 */
export const SIZE_FREEZE_EPSILON = 0.5;
